function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
import { validatePackage } from '@progress/kendo-vue-common';
import { packageMetadata } from '../package-metadata'; // tslint:enable:max-line-length

var SkeletonVue2 = {
  name: 'KendoSkeleton',
  props: {
    animation: {
      type: [Object, Boolean],
      default: function _default() {
        return {
          type: 'pulse'
        };
      },
      validator: function validator(value) {
        return ['wave', 'pulse'].includes(value.type);
      }
    },
    shape: {
      type: String,
      default: 'text',
      validator: function validator(value) {
        return ['circle', 'rectangle', 'text'].includes(value);
      }
    }
  },
  created: function created() {
    validatePackage(packageMetadata);
  },
  computed: {
    skeletonClasses: function skeletonClasses() {
      return {
        'k-skeleton': true,
        'k-skeleton-circle': this.shape === 'circle',
        'k-skeleton-rectangle': this.shape === 'rectangle',
        'k-skeleton-text': this.shape === 'text',
        'k-skeleton-pulse': _typeof(this.animation) === 'object' && this.animation.type === 'pulse',
        'k-skeleton-wave': _typeof(this.animation) === 'object' && this.animation.type === 'wave' || this.animation === true
      };
    }
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    return h("span", {
      "class": this.skeletonClasses
    });
  }
};
var Skeleton = SkeletonVue2;
export { Skeleton, SkeletonVue2 };